// extracted by mini-css-extract-plugin
export default {"footer":"footer___pJsxd3a","container":"container___pJsxd3a","copyright":"copyright___pJsxd3a","contacts":"contacts___pJsxd3a","email":"email___pJsxd3a"};